import React from 'react';
import classNames from 'classnames';
import { Button } from 'antd';
import config from './typeConfig';
import styles from './index.less'
import { getUserPermission } from 'src/common/gobalState';

const Exception = ({ className, type, title, desc, img, actions, ...rest }) => {
  const pageType = type in config ? type : '404';
  const clsString = classNames(styles.exception, className);
  const permission = getUserPermission();
  console.log("permission", permission);
  return (
    <div className={clsString} {...rest}>
      <div className={styles.imgBlock}>
        <div className={styles.imgEle} style={{ backgroundImage: `url(${img || config[pageType].img})` }} />
      </div>
      <div className={styles.content}>
        <h1>{title || config[pageType].title}</h1>
        <div className={styles.desc}>{desc || config[pageType].desc}</div>
        { JSON.stringify(permission) !== '{}' && type === '403'
          ? <div className={styles.actions}>
              {actions || (
                <Button
                  type="primary"
                  onClick={() => {
                    window.location.href = '/';
                  }}
                >
                  {i('返回首页')}
                </Button>
              )}
            </div>
          : null
        }
      </div>
    </div>
  );
};

export default Exception;
